import { render, staticRenderFns } from "./CardInstrumentoProtesto.vue?vue&type=template&id=279e54ba&scoped=true"
import script from "./CardInstrumentoProtesto.vue?vue&type=script&lang=js"
export * from "./CardInstrumentoProtesto.vue?vue&type=script&lang=js"
import style0 from "./CardInstrumentoProtesto.vue?vue&type=style&index=0&id=279e54ba&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "279e54ba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/thales/Recuperi/recuperi/recuperi-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('279e54ba')) {
      api.createRecord('279e54ba', component.options)
    } else {
      api.reload('279e54ba', component.options)
    }
    module.hot.accept("./CardInstrumentoProtesto.vue?vue&type=template&id=279e54ba&scoped=true", function () {
      api.rerender('279e54ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/CardInstrumentoProtesto.vue"
export default component.exports